export function parseFlexibleDate(value: any): Date | null {
  if (value == null || value === '') {
    return null;
  }
  if (value instanceof Date) {
    return isNaN(value.getTime()) ? null : value;
  }

  const raw = String(value).trim();
  const parts = /^(\d{1,4})[-/.](\d{1,2})[-/.](\d{1,4})/.exec(raw);
  if (parts) {
    const a = parseInt(parts[1], 10);
    const b = parseInt(parts[2], 10);
    const c = parseInt(parts[3], 10);
    const candidates = dateCandidates(a, b, c);
    for (let i = 0; i < candidates.length; i++) {
      if (candidates[i]) {
        return candidates[i];
      }
    }
    return null;
  }

  const fallback = new Date(raw);
  return isNaN(fallback.getTime()) ? null : fallback;
}

export function formatFlexibleDate(value: any, separator = '/'): string {
  const date = parseFlexibleDate(value);
  if (!date) {
    return value == null || value === '' ? '' : String(value);
  }
  const day = String(date.getDate());
  const month = String(date.getMonth() + 1);
  const year = String(date.getFullYear());
  const dd = day.length < 2 ? '0' + day : day;
  const mm = month.length < 2 ? '0' + month : month;
  return dd + separator + mm + separator + year;
}

export function formatFlexibleDateLocale(value: any, locale: string): string {
  const date = parseFlexibleDate(value);
  if (!date) {
    return '';
  }
  return date.toLocaleDateString(locale);
}

function dateCandidates(a: number, b: number, c: number): Array<Date | null> {
  if (a >= 1000) {
    return [
      makeLocalDate(a, b, c),
      makeLocalDate(a, c, b)
    ];
  }
  if (c >= 1000) {
    return [
      makeLocalDate(c, b, a),
      makeLocalDate(c, a, b)
    ];
  }
  return [];
}

function makeLocalDate(year: number, month: number, day: number): Date | null {
  if (month < 1 || month > 12 || day < 1 || day > 31) {
    return null;
  }
  const date = new Date(year, month - 1, day);
  if (isNaN(date.getTime())) {
    return null;
  }
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }
  return date;
}
